import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as roomRTC from "../services/roomRTC";
import { getUserSignOut } from '../services/api';
import { ToastContainer } from "react-toastify";

import Navbar from '../components/Navbar/Navbar';
import Overlay from '../components/Overlay/Overlay';
import InputJoinRoom from '../components/Home/InputJoinRoom';
import UsersLoggeds from '../components/Home/UsersLoggeds';
import ChatPrivate from '../components/Chats/ChatPrivate/ChatPrivate';
import ChatPublic from '../components/Chats/ChatPublic/ChatPublic';
import NoteChartView from '../components/Charts/NoteChartView';
import RoomListeners from '../components/Home/RoomListeners';
import RoomListenersPanel from '../components/Home/RoomListenersPanel';

import "../App.css";

const Home = ({ authToken, sessionId, isUserHost, username, roomSocketId, isShowOverlay }) => {
    useEffect(() => {
        const effectAsync = async () => {
            if (!authToken) {
                getUserSignOut({ roomSocketId });
            }

            await roomRTC.getInitialUserConnection(isUserHost, isUserHost, username, sessionId);
        };

        effectAsync();
    }, []);

    return (
        <div className="container-fluid home_container">
            <Navbar />

            <div className="row">
                <div className="col-md-3">
                    <InputJoinRoom />
                    <UsersLoggeds />
                    <ChatPrivate />
                </div>

                <div className="col-md-6">
                    <NoteChartView />
                </div>

                <div className="col-md-3">
                    <RoomListeners />
                    <ChatPublic />
                </div>
            </div>

            <RoomListenersPanel />

            {isShowOverlay && <Overlay />}

            <ToastContainer
                theme="dark"
                autoClose={3000}
                closeButton={false}
                position="top-right"
            />
        </div>
    )
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(Home);